<template>
  <div class="overflow-hidden overflow-x-auto relative">
    <FilterMenu
          :resource-name="resourceName"
          :soft-deletes="softDeletes"
          :via-resource="viaResource"
          :via-has-one="viaHasOne"
          :trashed="trashed"
          :per-page="perPage"
          :per-page-options="filterPerPageOptions"
          @clear-selected-filters="clearSelectedFilters(lens || null)"
          @filter-changed="filterChanged"
          @trashed-changed="trashedChanged"
          @per-page-changed="updatePerPageChanged"
        />
    <div v-for="(resource, index) in resources" class="well offer" bis_skin_checked="1">
                             <div class="flex flex-wrap" bis_skin_checked="1">
                                <div v-for="field in resource.fields" class="md:w-1/6 pr-4 pl-4 sm:w-1/2 pr-4 pl-4 mt-5" bis_skin_checked="1">
                                    
                                    <template v-if="field.component == 'advanced-media-library-field'">
                                      <strong>{{field.name}}</strong><br>
                                    <div v-if="field.type === 'media'">
                                      <img
                                        v-if="field.value[0]"
                                        :src="field.value[0].__media_urls__.indexView"
                                        style="object-fit: cover"
                                        class="rounded-full w-8 h-8"
                                      />
                                      <span v-else>&mdash;</span>
                                    </div>
                                    <div v-else>
                                      <span v-if="field.multiple">
                                        {{ field.value.map(({ file_name }) => file_name).join(', ') }}
                                      </span>
                                      <span v-else>
                                        {{ field.value[0].file_name }}
                                      </span>
                                    </div>
                                    </template>
                                    <template v-else-if="field.attribute == 'client'">
                                      <strong>{{field.name}}</strong>
                                      <br> 
                                      <a href="#" v-tooltip.click="__('Dane')" class="hover:text-primary-500 px-2" @click.stop="openClientModal(field.belongsToId)">
                                     
                                        {{field.displayAs || field.displayedAs || field.value}}
                                      </a>
                                    </template>
                                    <template v-else>
                                      <strong>{{field.name}}</strong><br> {{field.displayAs || field.displayedAs || field.value}}
                                    </template>
                                </div>
                               
                              
                          
                               
                                <template v-if="resource.authorizedToUpdate">
          <!-- Edit Pivot Button -->
          <Link
            v-if="
              relationshipType == 'belongsToMany' ||
              relationshipType == 'morphToMany'
            "
            v-tooltip.click="__('Edit Attached')"
            :aria-label="__('Edit Attached')"
            :dusk="`${resource['id'].value}-edit-attached-button`"
            :href="
              $url(
                `/resources/${viaResource}/${viaResourceId}/edit-attached/${resourceName}/${resource['id'].value}`,
                {
                  viaRelationship: viaRelationship,
                  viaPivotId: resource['id'].pivotValue,
                }
              )
            "
            class="toolbar-button hover:text-primary-500"
            @click.stop
          >
            <Icon type="pencil-alt" />
          </Link>

          <!-- Edit Resource Link -->
          <Link
            v-else
            v-tooltip.click="__('Edit')"
            :aria-label="__('Edit')"
            :dusk="`${resource['id'].value}-edit-button`"
            :href="
              $url(`/resources/${resourceName}/${resource['id'].value}/edit`, {
                viaResource: viaResource,
                viaResourceId: viaResourceId,
                viaRelationship: viaRelationship,
              })
            "
            class="toolbar-button hover:text-primary-500 px-2"
            @click.stop
          >
            <Icon type="pencil-alt" />
          </Link>
        </template>
         <button
          v-if="
            resource.authorizedToDelete &&
            (!resource.softDeleted || viaManyToMany)
          "
          v-tooltip.click="__(viaManyToMany ? 'Detach' : 'Delete')"
          :aria-label="__(viaManyToMany ? 'Detach' : 'Delete')"
          :data-testid="`${testId}-delete-button`"
          :dusk="`${resource['id'].value}-delete-button`"
          class="toolbar-button hover:text-primary-500 px-2"
          @click.stop="openDeleteModal(resource)"
        >
          <Icon type="trash" />
        </button>

        <button
          
          v-tooltip.click="__('Załączniki')"
          :aria-label="__('Załączniki')"
          :data-testid="`${testId}-attach-button`"
          :dusk="`${resource['id'].value}-attach-button`"
          class="toolbar-button hover:text-primary-500 px-2"
          @click.stop="openAttachModal(resource['id'].value)"
        >
          <Icon type="file" />Załączniki
        </button>
        <Link
            v-tooltip.click="__('Załączniki')"
            :aria-label="__('Załączniki')"
            :dusk="`${resource['id'].value}-attach-button`"
            :href="
              $url(`/resources/${resourceName}/${resource['id'].value}`, {
                viaResource: viaResource,
                viaResourceId: viaResourceId,
                viaRelationship: viaRelationship,
              })
            "
            class="toolbar-button hover:text-primary-500 px-2"
            @click.stop
          >
            <Icon type="file" />Załączniki 2
          </Link>
                             </div>
                            
                           </div>
   </div>
  

  <DeleteResourceModal
          :mode="viaManyToMany ? 'detach' : 'delete'"
          :show="deleteModalOpen"
          @close="closeDeleteModal"
          @confirm="confirmDelete"
        />

    <ClientResourceModal
          :client="client"
          :show="clientModalOpen"
          @close="closeClientModal"
        />

      <FilesResourceModal
          :resourceModal="resourceModal"
          :show="attachModalOpen"
          @close="closeAttachModal"
        />

</template>

<script>
import { InteractsWithResourceInformation } from '@/mixins'


export default {
  emits: ['actionExecuted', 'delete', 'restore', 'order', 'reset-order-by'],

  mixins: [InteractsWithResourceInformation],

  props: {
    authorizedToRelate: {
      type: Boolean,
      required: true,
    },
    resourceName: {
      default: null,
    },
    resources: {
      default: [],
    },
    singularName: {
      type: String,
      required: true,
    },
    selectedResources: {
      default: [],
    },
    selectedResourceIds: {},
    shouldShowCheckboxes: {
      type: Boolean,
      default: false,
    },
    actionsAreAvailable: {
      type: Boolean,
      default: false,
    },
    viaResource: {
      default: null,
    },
    viaResourceId: {
      default: null,
    },
    viaRelationship: {
      default: null,
    },
    relationshipType: {
      default: null,
    },
    updateSelectionStatus: {
      type: Function,
    },
    actionsEndpoint: {
      default: null,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selectAllResources: false,
    selectAllMatching: false,
    resourceCount: null,
    deleteModalOpen: false,
    clientModalOpen: false,
    attachModalOpen: false,
    deleteResourceState: null,
    client: null,
    resourceModal: null,
  }),

  methods: {
    /**
     * Delete the given resource.
     */
    deleteResource(resource) {
      this.$emit('delete', [resource])
    },

    /**
     * Restore the given resource.
     */
    restoreResource(resource) {
      this.$emit('restore', [resource])
    },

    /**
     * Broadcast that the ordering should be updated.
     */
    requestOrderByChange(field) {
      this.$emit('order', field)
    },

    /**
     * Broadcast that the ordering should be reset.
     */
    resetOrderBy(field) {
      this.$emit('reset-order-by', field)
    },

    openDeleteModal(resource) {
      this.deleteModalOpen = true
      this.deleteResourceState = resource
    },

    confirmDelete() {

      this.deleteResource(this.deleteResourceState)
      this.closeDeleteModal()
    },

    closeDeleteModal() {
      this.deleteModalOpen = false
      this.deleteResourceState = null
    },

    openClientModal(client) {
      //http://localhost:8000/nova-api/clients/1?relationshipType=
       Nova.request().get('/nova-api/clients/'+client)
       .then(response => {
          
          this.client = response.data.resource;
          this.clientModalOpen = true;
          console.log(response.data.resource.fields)
       });
     // this.deleteModalOpen = true;
    }, 
    closeClientModal(){
      this.clientModalOpen = false;
      this.client = null;
    },
    openAttachModal(id) {
       Nova.request().get('/nova-api/rents/'+id)
       .then(response => {
          
          this.resourceModal = response.data.resource;
          this.attachModalOpen = true;
       });
     // this.deleteModalOpen = true;
    }, 
    closeAttachModal(){
      this.attachModalOpen = false;
      this.resourceModal = null;
    }

  },

  computed: {
    /**
     * Get all of the available fields for the resources.
     */
    fields() {
      if (this.resources) {
        return this.resources[0].fields
      }
    },

    /**
     * Determine if the current resource listing is via a many-to-many relationship.
     */
    viaManyToMany() {
      return (
        this.relationshipType == 'belongsToMany' ||
        this.relationshipType == 'morphToMany'
      )
    },

    /**
     * Determine if the current resource listing is via a has-one relationship.
     */
    viaHasOne() {
      return (
        this.relationshipType == 'hasOne' || this.relationshipType == 'morphOne'
      )
    },

    /**
     * Determine if the resource table should show column borders.
     */
    shouldShowColumnBorders() {
      return this.resourceInformation.showColumnBorders
    },

    tableStyle() {
      return this.resourceInformation.tableStyle
    },

    clickAction() {
      return this.resourceInformation.clickAction
    },
    value() {
      return this.field.value[0];
    },

    imageUrl() {
      return this.value.__media_urls__.indexView;
    },
  },
}
</script>
